import { Component, Input, OnInit } from '@angular/core';
import { PmsService } from '../../pms/pms.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { UtilityFunctions } from 'src/app/utility/utils';
import { AssessmentService } from 'src/app/services/assessment.service';

@Component({
  selector: 'app-status-popup',
  templateUrl: './status-popup.component.html',
  styleUrls: ['./status-popup.component.css']
})
export class StatusPopupComponent implements OnInit {
  isExpanded = false;
  currentStep = 2;
  step: number = 1;
  status1: number = 1;
  milestoneData: any;
  prerequisitesPopup: any;
  prerequisitesList: any;
  images: any[] = [];
  value: any;
  displayBasic: any;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  @Input('statusData') set setData(data: any) {
    if (data) {
      this.milestoneData = data;
      console.log(data);
      this.DIS_Dispatch_Milestone_Documents_Get(data?.pk_dispatchId);
      if (data?.pk_dispatchId1) {
        this.DIS_Dispatch_Milestone_Documents_Get(data?.pk_dispatchId1);
      }
      this.isExpanded = false;
      this.isExpanded1 = false;
    }
  }
  constructor(private service: PmsService,
    private toster: ToasterService,
    private _pmsService: PmsService,
    private utils: UtilityFunctions,
    private _assessmentService: AssessmentService
  ) { }
  ngOnInit(): void {
  }

  labPrerequisites(id: any) {
    let req = {
      fk_labtypeId: id
    }
    this.prerequisitesPopup = true;
    this.service.DIS_LabPrerequisites_Get(req).subscribe({
      next: (res: any) => {
        if (res && res?._lstPrerequisiteData) {
          this.prerequisitesList = res;
        } else {
          this.prerequisitesList = null;
        }
      },
      error: (error) => {

      }
    })
  }
  listOfItemsPopup: any;
  listOfItemsList: any;
  listOfItems(id: any) {
    let req = {
      fk_labtypeId: id
    }
    this.listOfItemsPopup = true;
    this.service.DIS_LabItems_Get(req).subscribe({
      next: (res: any) => {
        if (res && res?._lstItemListData) {
          this.listOfItemsList = res;
        } else {
          this.listOfItemsList = null;
        }
      },
      error: (error) => {

      }
    })
  }
  docDetalis: any;
  docDetalis1: any;
  isExpanded1: any;
  viewDocDetails() {
    this.isExpanded = !this.isExpanded;
  }
  viewDocDetails1() {
    this.isExpanded1 = !this.isExpanded1;
  }
  DIS_Dispatch_Milestone_Documents_Get(id: any) {
    let req = {
      fk_dispatchId: id
    }

    this.service.DIS_Dispatch_Milestone_Documents_Get(req).subscribe({
      next: (res: any) => {
        if (id == this.milestoneData?.pk_dispatchId1) {
          this.docDetalis1 = res;
        } else {
          this.docDetalis = res;
        }
      },
      error: (error) => {

      }
    }
    )
  }
  imgPopup: any;
  docList: any = [];
  openImages(imgData: any) {
    this.imgPopup = true;
    let req = {
      pk_dispatchmilestonetrnId: imgData?.pk_dispatchmilestonetrnId
    }
    this.service.DIS_Dispatch_Milestone_Documents_View(req).subscribe({
      next: (res: any) => {
        this.docList = res?.listData;
        this.createImageObject();
      },
      error: (error) => {

      }
    })
  }

  createImageObject() {
    this.images = [];
    this.docList.forEach(element => {
      let imgObj = {
        itemImageSrc: '',
        thumbnailImageSrc: '',
        alt: '',
        title: ''
      }
      const data: string = element?.encdata || '';
      const ext = (element?.filename_act || '').split('.').pop()?.toLowerCase();
      // PDFs start with "JVBER" (%PDF) and cannot be shown in an <img>
      const isPdf = ext === 'pdf' || data.startsWith('JVBER');
      if (isPdf) {
        imgObj.thumbnailImageSrc = '/assets/images/nopdf.jpg';
        imgObj.itemImageSrc = '/assets/images/nopdf.jpg';
      } else {
        const mime = ext === 'jpg' || ext === 'jpeg' ? 'image/jpeg' : ext === 'gif' ? 'image/gif' : 'image/png';
        imgObj.thumbnailImageSrc = `data:${mime};base64,` + data;
        imgObj.itemImageSrc = `data:${mime};base64,` + data;
      }
      imgObj.title = element.filename_act;
      imgObj['base64'] = data;
      imgObj['isPdf'] = isPdf;
      this.images.push(imgObj);
    });
  }
  displayCustom: any;
  activeIndex: any;
  imageClick(index: number) {
    const item = this.images[index];
    if (item?.isPdf) {
      this.openPdf(item.base64);
      return;
    }
    this.activeIndex = index;
    this.displayCustom = true;
  }
  openPdf(base64: string) {
    const bytes = atob(base64);
    const arr = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
      arr[i] = bytes.charCodeAt(i);
    }
    const url = URL.createObjectURL(new Blob([arr], { type: 'application/pdf' }));
    window.open(url, '_blank');
  }
  downloadFile(base64: string, filename: string) {
    console.log(1);
    base64 = base64.replace(/^data:[^;]+;base64,/, "");
    let options = {}
    const filenameBlob = this._assessmentService.dataURItoBlob(base64);
    this.utils.createAndDownloadBlobFile(filenameBlob, options, filename);
  }

  printReport() {
    let req = {
      "reporttype": this.utils.getEncryptedValue(1),
      "fk_dispatchId": this.utils.getEncryptedValue(this.docList[0]?.fk_dispatchId),
      "fk_milestoneId": this.utils.getEncryptedValue(this.docList[0]?.fk_milestoneId)
    }
    this._pmsService.DIS_Milestone_Completion_Rpt_PDF_EXCEL(req).subscribe({
      next: (res) => {
        this.downloadF(res);
      },
      error: (error) => {

      }
    })
  }
  downloadF(res: any) {
    let options = {}
    const filenameBlob = this._assessmentService.dataURItoBlob(res['ReportData']);
    this.utils.createAndDownloadBlobFile(filenameBlob, options, res['ReportName']);
  }
}
